// extracted by mini-css-extract-plugin
export default {"container":"LoadingDiv__container___pER7u"};